import $ from 'jquery';

$(document).ready(function() {

  var $clearFilterReport = $('.clear-filter-report-js');
  var $clearFilterConfig = $('.clear-filter-config-js');

  var $selectPartnerConfig = $('.select-partner-config-js');
  var $selectSecretariesConfig = $('.select-secretaries-config-js');
  var $selectYearsConfig = $('.select-year-config-js');

  $clearFilterReport.click(function() {
    clearFilter('.select-partner-report-js', '.select-secretaries-report-js', '.select-year-report-js');
    $('#reportContent').html('');
  });

  $clearFilterConfig.click(function() {
    clearFilter('.select-partner-config-js', '.select-secretaries-config-js', '.select-year-config-js')
  });
});

function clearFilter(selectPartner, selectSecretaries, selectYear) {
  var $selectPartner = $(selectPartner);
  var $selectSecretaries = $(selectSecretaries);
  var $selectYears = $(selectYear);

  $selectPartner.prop('disabled', false);
  $selectSecretaries.prop('disabled', false);
  $selectYears.prop('disabled', false);

  $selectPartner.val($(selectPartner + " option:first").val());
  $(selectSecretaries + ' option:not(:first)').remove();
  $(selectYear + ' option:not(:first)').remove();

  $('#showConfiguration').html("");
  $('.btn-save-js').addClass('d-none');
  $('.btn-fixed-save-js').addClass('d-none');

}
